import React from "react";
import { USER_ROLE_NEWS_ALERTS } from "../common/roles/constants";
import useRolesVisibility from "../common/roles/useRolesVisibility";
import { RequiredRoles } from "../search/criteria/components/common/requiredRoles";

export function AlertLink() {
	const { hasRequiredRoles } = useRolesVisibility(
		RequiredRoles.showFor([USER_ROLE_NEWS_ALERTS]),
	);

	if (!hasRequiredRoles) {
		return null;
	}

	return (
		<a
			className="btn btn--secondary btn--has-icon btn--create-alert"
			href="/account-management/alerts"
		>
			<span>Create news email alert</span>
		</a>
	);
}
